export default __webpack_public_path__ + "static/media/n.22395717.gif";